import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatCalendar, MatCalendarCellCssClasses} from '@angular/material/datepicker';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

import * as moment from 'moment';
import {Moment} from 'moment';
import {ServiceConfig} from '../../models/Service';

import {ServiceModalData} from '../../models/ServiceModalData';
import {ApiService, AuthService, UserService} from '../../services';
import {InfoDialogComponent} from '../../shared/dialogs/info-dialog/info-dialog.component';
import {UserModel} from '../../shared/models/user.model';
import { HttpParams } from '@angular/common/http';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY'
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-service-modal',
  templateUrl: './service-modal.component.html',
  styleUrls: ['./service-modal.component.scss']
})
export class ServiceModalComponent implements OnInit {

  @ViewChild('calendar') calendar: MatCalendar<Moment>;
  @ViewChild('myCalendar') myCalendar: any;

  public isLoading = false;
  public dataInitialized = false;

  public serviceFormGroup: UntypedFormGroup;

  public code: string;
  public phone: string;

  public result = {statusCode: 0, statusMessage: ''};

  public langs = [];

  public servicePauseType = '1';
  public endDate = moment();
  public serviceConfig = new ServiceConfig();

  public calendarPauseType = '1';

  // calendar
  public selectedDate: any;
  public minDate: Moment = moment();
  public selectedDates = [];
  userSelectedDates = [];
  private currentUser: UserModel;


  constructor(
    public dialogRef: MatDialogRef<ServiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ServiceModalData,
    public API: ApiService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private userService: UserService,
    private Auth: AuthService) {
    this.translate.get(['sms_verification']).subscribe(t => {
      this.langs = t;
    });
  }

  ngOnInit() {
    console.log(this.data)
    this.userService.getUser
      .subscribe((user) => {
        this.currentUser = new UserModel().deserialize(user);
        if (this.currentUser.isClinicAdmin && !this.currentUser.clinics[0].homeVisitEnabled) {
          this.data.serviceTypes = this.data.serviceTypes.filter(type => type.key !== 2);
        }
      });
    this.initFormGroups();

    if (this.data.type == 2 && this.data.service.doctorServiceId) {
      this.initServiceGroups(this.data.service.specialityId);
      this.initServiceCategories(this.data.service.serviceGroupId);
      this.initServiceConfigs();
    }
  }

  initFormGroups() {
    this.serviceFormGroup = new UntypedFormGroup({
      serviceTypeId: new UntypedFormControl(null, [
        Validators.required
      ]),
      specialityId: new UntypedFormControl(null, [
        Validators.required
      ]),
      serviceGroupId: new UntypedFormControl(null, [
        Validators.required
      ]),
      serviceGroupCategoryId: new UntypedFormControl(null, [
        Validators.required
      ]),
      specialityServiceConfigId: new UntypedFormControl(null, [
        Validators.required
      ]),
      price: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(this.serviceConfig.priceFrom),
        Validators.max(this.serviceConfig.priceTo)
      ]),
      commissionDoctor: new  UntypedFormControl(this.data?.service?.commissionDoctor || null, [
        Validators.required
      ])
    });
  }

  addService(): void {
    if (!this.serviceFormGroup.valid) {
      return;
    }

    this.API.addDoctorService({...this.data.service, commissionDoctor: this.serviceFormGroup.value.commissionDoctor}, this.data.clinicAdminHttpParams).subscribe(
      res => {
        if (res) {

        }
        this.result.statusCode = 1;
        this.result.statusMessage = this.translate.instant('information-has-been-added-succesfully');
        this.dialogRef.close(this.result);
      },
      error => {
        const dialog = this.dialog.open(InfoDialogComponent, {
          data: {
            message: error.error.Error.ErrorMessage,
            needsAction: false, 
            title: 'failure'
          }
        });
        dialog.afterOpened().subscribe(() => {
          setTimeout(() => {
            dialog.close();
          }, 5000);
        });
        // this.result.statusCode = 0;
        // this.result.statusMessage = error.error.Error.ErrorMessage;
        // this.dialogRef.close(this.result);
      }
    );

  }

  editService(): void {
    if (!this.serviceFormGroup.valid) {
      return;
    }
    const data = this.serviceFormGroup.value;
    data['DoctorServiceId'] = this.data.service.doctorServiceId;
    this.API.editDoctorService(this.serviceFormGroup.value, this.data.clinicAdminHttpParams).subscribe(
      res => {
        if (res) {

        }
        this.result.statusCode = 1;
        this.result.statusMessage = this.translate.instant('information-has-been-updated-successfully');
        this.dialogRef.close(this.result);
      },
      error => {
        this.result.statusCode = 0;
        this.result.statusMessage = error.error.Error.ErrorMessage;
        this.dialogRef.close(this.result);
      }
    );

  }

  pauseService(): void {
    this.isLoading = true;
    if (this.servicePauseType == '2') {
      const today = moment();
      const daysToAddtoday = 7 - today.day();
      const newDate = this.endDate.date() + daysToAddtoday;
      this.endDate.date(newDate);
    }
    if (this.servicePauseType == '3') {
      this.endDate = this.selectedDate;
    }
    this.endDate.hour(23);
    this.endDate.minute(59);
    this.endDate.second(59);
    this.API.pauseDoctorService(this.data.checkedServicesIDs, this.endDate, this.data.clinicAdminHttpParams).subscribe(
      res => {
        if (res) {

        }
        this.result.statusCode = 1;
        this.result.statusMessage = this.translate.instant('service-has-been-paused-successfully');
        this.dialogRef.close(this.result);
      },
      error => {
        this.result.statusCode = 0;
        this.result.statusMessage = error.error.Error.ErrorMessage;
        this.dialogRef.close(this.result);
      }
    );
  }


  public hasError = (controlName: string, errorName: string) => {
    return this.serviceFormGroup.controls[controlName].hasError(errorName);
  };

  public isValid = (controlName: string) => {
    return this.serviceFormGroup.controls[controlName].status != 'INVALID';
  };

  onCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  onCloseCancel() {
    this.dialogRef.close('Cancel');
  }

  close() {
    this.dialogRef.close(this.result);
  }

  onDateChanged(event) {
    if (!this.userSelectedDates.length || !this.userSelectedDates.includes(event)) {
      this.userSelectedDates.push(event);
    } else if (this.userSelectedDates.includes(event)) {
      this.userSelectedDates.splice(this.userSelectedDates.indexOf(event), 1);
    }
    this.selectedDate = event;
    this.selectedDates = this.getDateArray(this.minDate, this.selectedDate);


    console.log(this.userSelectedDates)
    if(this.userSelectedDates[this.userSelectedDates.length-1].length>2 && Number.parseInt(this.calendarPauseType) === 3){
    
      this.userSelectedDates=[];
      this.myCalendar.resetSelections();
    }
    if(this.userSelectedDates[this.userSelectedDates.length-1].length==1 && Number.parseInt(this.calendarPauseType) === 3){
      this.myCalendar.resetLights();
    }
    if(this.userSelectedDates[this.userSelectedDates.length-1].length<3 && this.userSelectedDates[this.userSelectedDates.length-1].length>1 && Number.parseInt(this.calendarPauseType) === 3){
      if(this.userSelectedDates[this.userSelectedDates.length-1][0]<this.userSelectedDates[this.userSelectedDates.length-1][1]){
            let date1 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][0])
            date1.setDate(date1.getDate() + 1);
            let date2 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][1])
            date2.setDate(date2.getDate() - 1);
            this.myCalendar.selectedDayInRange(date1,date2)
          } else {
            let date1 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][0])
            date1.setDate(date1.getDate() - 1);
            let date2 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][1])
            date2.setDate(date2.getDate() + 1);
            this.myCalendar.selectedDayInRange(date2,date1)
          }
    }
   
    // this.calendar.updateTodaysDate();
  }

  monthSelected(event) {
    console.log(event);
  }

  dateClass() {
    return (date: Moment): MatCalendarCellCssClasses => {
      date = moment(date);
      const highlightDate = this.selectedDates
        .map(strDate => moment(strDate))
        .some(d => d.date() === date.date() && d.month() === date.month() && d.year() === date.year());

      return highlightDate ? 'selected-date' : '';
    };
  }

  getDateArray(start, end) {
    const arr = [];
    const dt = moment(start);

    while (dt <= end) {
      arr.push(moment(dt));
      dt.date(dt.date() + 1);
    }
    return arr;
  }

  setServicePauseType(event) {

  }

  setCalendarPauseType(event) {
  
  }

  onChangeType() {
    this.data.service.specialityId = null;
    this.data.service.serviceGroupId = null;
    this.data.serviceGroups = [];

    this.data.service.serviceGroupCategoryId = null;
    this.data.serviceCategories = [];

    this.data.service.specialityServiceConfigId = null;
    this.data.serviceConfigs = [];
    this.serviceConfig.commissionDoctor = null;
    this.serviceConfig.commissionPatient = null;
    this.serviceConfig.priceFrom = null;
    this.serviceConfig.priceTo = null;
    this.initServiceConfigs();

    // this.initServiceGroups(id);
  }

  onChangeSpeciality(id) {
    this.data.service.serviceGroupId = null;
    this.data.serviceGroups = [];

    this.data.service.serviceGroupCategoryId = null;
    this.data.serviceCategories = [];

    this.data.service.specialityServiceConfigId = null;
    this.data.serviceConfigs = [];
    this.serviceConfig.commissionDoctor = null;
    this.serviceConfig.commissionPatient = null;
    this.serviceConfig.priceFrom = null;
    this.serviceConfig.priceTo = null;
    this.initServiceGroups(id);
    this.initServiceConfigs();

  }

  onChangeGroup(id) {
    this.data.service.serviceGroupCategoryId = null;
    this.data.serviceCategories = [];

    this.data.service.specialityServiceConfigId = null;
    this.data.serviceConfigs = [];
    this.serviceConfig.commissionDoctor = null;
    this.serviceConfig.commissionPatient = null;
    this.serviceConfig.priceFrom = null;
    this.serviceConfig.priceTo = null;
    this.initServiceCategories(id);
    this.initServiceConfigs();

  }

  onChangeCategory() {
    this.data.service.specialityServiceConfigId = null;
    this.data.serviceConfigs = [];
    this.serviceConfig.commissionDoctor = null;
    this.serviceConfig.priceFrom = null;
    this.serviceConfig.priceTo = null;
    this.serviceConfig.commissionPatient = null;
    this.initServiceConfigs();
  }

  onChangeConfig(obj) {
    this.serviceConfig = new ServiceConfig(obj);
    this.data.service.commissionDoctor = this.serviceConfig.commissionDoctor;
    this.data.service.commissionPatient = this.serviceConfig.commissionPatient;
    this.setPriceValidator();
  }

  setPriceValidator() {
    if (this.data.service.price >= this.serviceConfig.priceFrom
      && this.data.service.price <= this.serviceConfig.priceTo) {
      this.serviceFormGroup.controls['price'].setErrors(null);
    }

    this.serviceFormGroup.controls['price'].setValidators([
      Validators.required,
      Validators.min(this.serviceConfig.priceFrom),
      Validators.max(this.serviceConfig.priceTo)
    ]);
  }

  initServiceGroups(id) {
    this.API.getServiceGroup(id).subscribe(
      res => {
        if (res) {
          if (res.hasOwnProperty('result')) {
            this.data.serviceGroups = res['result'];
          }
          this.dataInitialized = true;
        }
      }, error => {
        this.Auth.checkAccess(error);
      }
    );
  }

  initServiceCategories(id) {
    this.API.getServiceCategory(id).subscribe(
      res => {
        if (res) {
          if (res.hasOwnProperty('result')) {
            this.data.serviceCategories = res['result'];
          }
          this.dataInitialized = true;
        }
      }, error => {
        this.Auth.checkAccess(error);
      }
    );
  }

  initServiceConfigs() {
    const data = {
      'SpecialityId': this.data.service.specialityId,
      'ServiceGroupId': this.data.service.serviceGroupId,
      'ServiceGroupCategoryId': this.data.service.serviceGroupCategoryId,
      'ServiceTypeId': this.data.service.serviceTypeId
    };

    this.API.getSpecialityServiceConfig(data).subscribe(
      res => {
        if (res) {
          if (res.hasOwnProperty('result')) {

          }
          this.data.serviceConfigs = this.parseServiceConfig(res);

          if (this.data.service.doctorServiceId) {
            this.serviceConfig = new ServiceConfig(this.getServiceConfigId());
            this.data.service.commissionDoctor = this.serviceConfig.commissionDoctor;
            this.data.service.commissionPatient = this.serviceConfig.commissionPatient;
            this.setPriceValidator();
          }
          this.dataInitialized = true;
        }
      }, error => {
        this.Auth.checkAccess(error);
      }
    );
  }

  getServiceConfigId() {
    for (let i = 0; i < this.data.serviceConfigs.length; i++) {
      if (this.data.serviceConfigs[i].specialityServiceConfigId == this.data.service.specialityServiceConfigId) {
        return this.data.serviceConfigs[i];
      }
    }
    return null;
  }

  parseServiceConfig(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
      newArr.push(new ServiceConfig(arr[i]));
    }
    return newArr;
  }

  getPricePercent(price, percent) {
    if (!price || !percent) {
      return '-';
    }
    return (price * percent / 100).toFixed(2);
  }

  getPriceDoctor(price, percentDoctor) {
    if (!price || !percentDoctor) {
      return '-';
    }
    return ((price * percentDoctor) / 100).toFixed(2);
  }

  pauseCalendar(): void {
    console.log(this.data.clinicAdminHttpParams)
    if (Number.parseInt(this.calendarPauseType) === 3) {
      if(this.userSelectedDates.length>1){
        let updatedParams = new HttpParams({ fromString: this.data.clinicAdminHttpParams.toString() });
        if(this.userSelectedDates[this.userSelectedDates.length-1][0]<this.userSelectedDates[this.userSelectedDates.length-1][1]){
          let date1 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][0])
          date1.setDate(date1.getDate() + 1);
          let newIsoDate1 = date1.toISOString();
          let date2 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][1])
          date2.setDate(date2.getDate() + 1);
          let newIsoDate2 = date2.toISOString();
          updatedParams = updatedParams.set('start-date',newIsoDate1);
          updatedParams = updatedParams.set('end-date', newIsoDate2);
        } else {
          let date1 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][0])
          date1.setDate(date1.getDate() + 1);
          let newIsoDate1 = date1.toISOString();
          let date2 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][1])
          date2.setDate(date2.getDate() + 1);
          let newIsoDate2 = date2.toISOString();
          updatedParams = updatedParams.set('start-date', newIsoDate2);
          updatedParams = updatedParams.set('end-date', newIsoDate1);
        }
        
        console.log(updatedParams, 'updated params');
        this.API.pauseDoctorCalendarManual(this.data.checkedCalendarIDs,updatedParams).subscribe( res => {
          this.result.statusCode = 1;
          this.result.statusMessage = this.translate.instant('service-has-been-paused-successfully');
          this.dialogRef.close(this.result);
        },
        error => {
          this.result.statusCode = 0;
          this.result.statusMessage = error.error.Error.ErrorMessage;
          this.dialogRef.close(this.result);
        })
      } else {
        let updatedParams = new HttpParams({ fromString: this.data.clinicAdminHttpParams.toString() });
        let date1 = new Date(this.userSelectedDates[this.userSelectedDates.length-1][0])
        date1.setDate(date1.getDate() + 1);
        let newIsoDate1 = date1.toISOString();
        updatedParams = updatedParams.set('start-date', newIsoDate1);
        updatedParams = updatedParams.set('end-date', newIsoDate1);
    
        console.log(updatedParams, 'updated params');
        this.API.pauseDoctorCalendarManual(this.data.checkedCalendarIDs,updatedParams).subscribe( res => {
          this.result.statusCode = 1;
          this.result.statusMessage = this.translate.instant('service-has-been-paused-successfully');
          this.dialogRef.close(this.result);
        },
        error => {
          this.result.statusCode = 0;
          this.result.statusMessage = error.error.Error.ErrorMessage;
          this.dialogRef.close(this.result);
        })
      }
  } else {
    this.isLoading = true;
    this.API.pauseDoctorCalendar(this.data.checkedCalendarIDs, Number.parseInt(this.calendarPauseType), this.data.clinicAdminHttpParams)
      .subscribe(
        res => {
          this.result.statusCode = 1;
          this.result.statusMessage = this.translate.instant('service-has-been-paused-successfully');
          this.dialogRef.close(this.result);
        },
        error => {
          this.result.statusCode = 0;
          this.result.statusMessage = error.error.Error.ErrorMessage;
          this.dialogRef.close(this.result);
        }
      );
  }}
}
